
import { defineComponent, ref } from 'vue'
import { useAgreementModule } from '@/modules/agreements'

export default defineComponent({
    name: 'invoices-form-field-agreement-name',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        }
    },
    async setup (_, { emit }) {
        const { getAgreementsSimplified, agreementsSimplified } = useAgreementModule()
        await getAgreementsSimplified()

        const agreementsOptions = agreementsSimplified.value.map((agreement) => agreement.name)
        const filteredOptions = ref(agreementsOptions)

        const filterFn = (val: string, update: (arg: () => void) => void) => {
            update(() => {
                const needle = val.toLowerCase()
                filteredOptions.value = agreementsOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
            })
        }

        const onUpdate = (value: string | null) => {
            if (value === null) {
                value = ''
            }
            emit('update:modelValue', value)
        }

        return {
            filteredOptions,
            filterFn,
            onUpdate
        }
    }
})
